import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';


import * as configActions from '../configActions';
import * as configSelectors from '../configSelectors';

import configService from '../../../../services/ConfigService';


function UserConfiguration({children}) {

    const isUserConfigLoading = useSelector(configSelectors.isUserConfigLoading);
    const isUserConfigLoaded = useSelector(configSelectors.isUserConfigLoaded);
    const dispatch = useDispatch();

    useEffect(() => {

        if (!isUserConfigLoaded) {

            if (!isUserConfigLoading) {

                dispatch(configActions.onUserConfigLoading());

                (async () => {

                    const userConfig = await configService.loadUserConfig();
                    dispatch(configActions.onUserConfigLoaded(userConfig));
                })();
            }
        }

    }, [isUserConfigLoading, isUserConfigLoaded]);

    if (!isUserConfigLoaded) {

        return null;
    }

    return children;
}


UserConfiguration.propTypes = {
    children: PropTypes.any
};


export default UserConfiguration;
